import { Route, Redirect, useLocation } from 'react-router-dom';
import { rememberAuthDestination } from 'src/utils/authContinuation';
import useSessionStore from 'src/stores/session';
import queryString from 'qs';

import AppRouteLoader from 'src/components/Loading/AppRouteLoader';
import ROUTES from 'src/router/routes';
import { ROUTES_URL } from 'src/constants/routes';

import useUserStore from 'src/stores/user';

import BeginWorkProtectedRoute from './BeginWorkProtectedRoute';

import type { RouteProps } from 'react-router-dom';

interface IProtectedRoute extends RouteProps {
    path: string;
    noCheckIsApproved?: boolean;
}

export default function ProtectedRoute({ path, ...otherProps }: IProtectedRoute) {
    const location = useLocation();
    const { isAuthorized, hasSessionSnapshot } = useSessionStore(({ isAuthorized, hasSessionSnapshot }) => ({
        isAuthorized,
        hasSessionSnapshot,
    }));
    const isEmailConfirmed = useUserStore(({ isEmailConfirmed }) => isEmailConfirmed);

    if (!isAuthorized) {
        const destination = location.pathname + location.search + location.hash;
        rememberAuthDestination(destination);
        return (
            <Redirect
                to={{
                    pathname: ROUTES.LOGIN.path,
                    search: queryString.stringify(
                        {
                            backUrl: destination,
                        },
                        { skipNulls: true }
                    ),
                }}
            />
        );
    }

    if (!hasSessionSnapshot) {
        return <AppRouteLoader />;
    }

    if (path.includes(ROUTES_URL.BEGIN_WORK)) {
        return (
            <BeginWorkProtectedRoute
                path={path}
                {...otherProps}
            />
        );
    }

    if (!isEmailConfirmed && path !== ROUTES_URL.WELCOME_SCREEN) {
        return <Redirect to={ROUTES_URL.WELCOME_SCREEN} />;
    }

    return (
        <Route
            path={path}
            {...otherProps}
        />
    );
}
